import { makeStyles } from '@material-ui/core'

export const logsStyles = makeStyles((theme: any) => {
  return {
    headerWrapper: {
      padding: theme.spacing(1),
      height: theme.logs.titleHeight,
    },
    exportButton: {
      position: 'absolute',
      left: '50%',
      right: '50%',
      bottom: '10px',
      width: 'fit-content',
    },
    exportButtonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.logs.buttonWrapperHeight,
    },
  }
})

